export default "__VITE_ASSET__CVM9S62j__"